"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStyles2 = exports.mapStyles = void 0;
exports.mapStyles = [];
exports.mapStyles2 = [
    {
        featureType: 'landscape.natural',
        elementType: 'geometry.fill',
        stylers: [
            {
                visibility: 'on',
            },
            {
                color: '#e0efef',
            },
        ],
    },
    {
        featureType: 'poi',
        elementType: 'geometry.fill',
        stylers: [
            {
                visibility: 'on',
            },
            {
                hue: '#1900ff',
            },
            {
                color: '#c0e8e8',
            },
        ],
    },
    {
        featureType: 'poi',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'on',
            },
        ],
    },
    {
        featureType: 'poi',
        elementType: 'labels.icon',
        stylers: [],
    },
    {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
            {
                lightness: 100,
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
            {},
        ],
    },
    {
        featureType: 'water',
        elementType: 'all',
        stylers: [
            {
                color: '#7dcdcd',
            },
        ],
    },
];
